export default function Footer() {
  return (
    <footer className="mx-auto flex min-w-64 max-w-4xl justify-between px-4 pb-12 pt-8 font-mono">
      <a
        className="text-gray-300 hover:text-white"
        href="https://github.com/chadluo/hnr5"
        target="_blank"
        rel="noreferrer"
      >
        chadluo/hnr5
      </a>
      <a
        className="text-gray-300 hover:text-white"
        href="https://github.com/sponsors/chadluo"
        target="_blank"
        rel="noreferrer"
      >
        sponsor
      </a>
    </footer>
  );
}
